var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgClose = function SvgClose(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    className: "close_svg__svg-icon",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "close_svg__close"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M18.3 5.71a.996.996 0 0 0-1.41 0L12 10.59 7.11 5.7A.996.996 0 1 0 5.7 7.11L10.59 12 5.7 16.89a.996.996 0 1 0 1.41 1.41L12 13.41l4.89 4.89a.996.996 0 1 0 1.41-1.41L13.41 12l4.89-4.89c.38-.38.38-1.02 0-1.4",
    className: "close_svg__vector"
  }))));
};
export { SvgClose as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGZpbGw9Im5vbmUiIHZpZXdCb3g9IjAgMCAyNCAyNCIgY2xhc3M9InN2Zy1pY29uIj48ZyBjbGFzcz0iY2xvc2UiPjxwYXRoIGZpbGw9ImN1cnJlbnRDb2xvciIgZD0iTTE4LjMgNS43MWEuOTk2Ljk5NiAwIDAgMC0xLjQxIDBMMTIgMTAuNTkgNy4xMSA1LjdBLjk5Ni45OTYgMCAxIDAgNS43IDcuMTFMMTAuNTkgMTIgNS43IDE2Ljg5YS45OTYuOTk2IDAgMSAwIDEuNDEgMS40MUwxMiAxMy40MWw0Ljg5IDQuODlhLjk5Ni45OTYgMCAxIDAgMS40MS0xLjQxTDEzLjQxIDEybDQuODktNC44OWMuMzgtLjM4LjM4LTEuMDIgMC0xLjRaIiBjbGFzcz0idmVjdG9yIi8+PC9nPjwvc3ZnPg==";